module.exports = __webpack_public_path__ + "img/PL00272.b1cf7d59.png";